import { Affix, Space } from 'antd';

/**
 * Барааны формуудын доод талын үйлдлийн мөр.
 * Дэлгэцийн доод хэсэгт наалдана — урт форм гүйлгэхэд ч товчнууд харагдана.
 * `extra` талбарт нийт дүн зэрэг товч мэдээллийг зүүн талд харуулна.
 */
const FormFooter = ({ extra = null, children }) => (
  <Affix offsetBottom={16}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: 12,
        backgroundColor: '#fff',
        border: '1px solid #f1f2f4',
        borderRadius: 8,
        boxShadow: '0 1px 2px rgba(16, 22, 26, 0.04)',
      }}
    >
      <div>{extra}</div>
      <Space size={8}>{children}</Space>
    </div>
  </Affix>
);

export default FormFooter;
